/* eslint-disable react/prop-types */
import { TableCell } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import { StyledTableRow } from "components/BulkUpload";
import i18n from "i18next";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getActivityGroupByLanguage,
  getErrors,
  getJobFamiliesByLanguage,
} from "./utils";

import { getProjectInfoEntryType } from "utils";

const leaveOptions = [
  { name: "Annual leave", id: "d1" },
  { name: "Sick Leave", id: "d2" },
  { name: "Casual Leave", id: "d3" },
  { name: "", id: "d4" },
];

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const lgUp = "79px";
const lgDown = "70px";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
  formControl: {
    minWidth: "200px",
  },
  hrsField: {
    minWidth: lgDown,
    maxWidth: lgDown,
  },
  [theme.breakpoints.up("xl")]: {
    hrsField: {
      minWidth: lgUp,
      maxWidth: lgUp,
    },
  },
  number: {
    fontSize: 14,
    textAlign: "center",
    "&[type=number]": {
      "-moz-appearance": "textfield",
      "-webkit-appearance": "textfield",
    },
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
}));

const PunchRow = (props) => {
  const classes = useStyles();
  const {
    disabled,
    record,
    index,
    register,
    control,
    onUpdate,
    setValue,
    getValues,
    trigger,
    errors,
    dropdowns,
  } = props;

  const appConfig = useSelector((state) => state.appConfig);
  const user = dropdowns && dropdowns.selectedWorker;
  const { jobFamilies, activityGroups, projectDetailsByCountry } = appConfig;

  const [group, setGroup] = useState("");
  const [jobfamily, setJobfamily] = useState("");
  const [project, setProject] = useState("");
  const [showFreeForm, setShowFreeForm] = useState(false);
  const [isDisabled, setDisabled] = useState(false);

  const [jobFamiliyOption, setJobFamilyOption] = useState([]);
  const [activityGroupOption, setActivityGroupOption] = useState([]);
  const [projectOption, setProjectOptions] = useState([]);
  const { t } = useTranslation();
  const timesheetActivtyGroup = t("other.timeSheetActivityGroup") + "*";
  const timesheetJobFamily = t("other.timeSheetJobFamily") + "*";

  const filterDetailsByActivityGroup = (projectDetailsByCountry, group) => {
    if (projectDetailsByCountry == null) return [];
    const detailsByProject = [];
    projectDetailsByCountry.filter((projectDetail, index, projectDetails) => {
      if (projectDetail.activityGroup === group.value) {
        detailsByProject.push(projectDetail);
      }
    });

    const detailByJobRoleRestricted = [];

    detailsByProject.map((detail, index) => {
      if (detail.isJobRoleRestricted !== undefined) {
        if (
          detail.isJobRoleRestricted === true &&
          detail.jobRoles.includes(jobfamily)
        ) {
          detailByJobRoleRestricted.push(detail);
        } else if (detail.isJobRoleRestricted === false) {
          detailByJobRoleRestricted.push(detail);
        }
      } else {
        detailByJobRoleRestricted.push(detail);
      }
    });

    return detailByJobRoleRestricted;
  };

  useEffect(() => {
    let jobFamilyOptions =
      jobFamilies !== null
        ? getJobFamiliesByLanguage(i18n.language, jobFamilies)
        : [];
    jobFamilyOptions =
      user && user.isApprover
        ? jobFamilyOptions
        : jobFamilyOptions.filter((item) => !item.mgrOnly);
    const activityGroupsOptions =
      activityGroups !== null
        ? getActivityGroupByLanguage(i18n.language, activityGroups)
        : [];
    const detailsByProject = filterDetailsByActivityGroup(
      projectDetailsByCountry,
      group
    );
    let projectOptions = detailsByProject.filter((e) => e.isActive);
    setJobFamilyOption(jobFamilyOptions);
    setActivityGroupOption([...activityGroupsOptions]);
    setProjectOptions([...projectOptions]);
  }, [
    jobFamilies,
    activityGroups,
    projectDetailsByCountry,
    group,
    i18n,
    jobfamily,
  ]);

  useEffect(() => {
    register(`records[${index}].details`);
    register(`records[${index}].showFreeForm`);
    register(`records[${index}].freeForm`);
    setValue(`records[${index}].details`, record.details);
    if (record.group) setGroup({ value: record.group });
    if (record.freeForm) setProject(record.freeForm);
    if (record.showFreeForm) setShowFreeForm(record.showFreeForm);
    if (record.group) {
      if (record.group == "Leave") {
        setProject(record.details);
      }
    }
  }, [record]);

  useEffect(() => {
    let show = showFreeForm;
    if (group) {
      if (projectOption.length == 0) {
        show = true;
      } else {
        show = false;
      }
    } else {
      show = false;
    }
    setValue(`records[${index}].showFreeForm`, show);
    setShowFreeForm(show);
  }, [group, projectOption]);

  useEffect(() => {
    let gValid = group ? true : false;
    let fValid =
      group && group.value == "Leave" ? true : jobfamily ? true : false;
    setDisabled(!fValid || !gValid);
    if (activityGroupOption) {
      let filteredActGrps = [];
      let filteredActivityGroups = jobFamiliyOption.filter((item) => {
        return (
          item.actGrpsRestrctd === true &&
          item.actGrps.length > 0 &&
          item.value === jobfamily
        );
      });
      if (filteredActivityGroups && filteredActivityGroups.length > 0) {
        const restrictedActGrps = filteredActivityGroups[0].actGrps;
        const activityGroupsOptions =
          activityGroups !== null
            ? getActivityGroupByLanguage(i18n.language, activityGroups)
            : [];
        filteredActGrps = activityGroupsOptions.filter(
          (item) =>
            restrictedActGrps.includes(item.value) ||
            item.value.toLowerCase() === "leave" ||
            item.value.toLowerCase() === "meal"
        );
        setActivityGroupOption([...filteredActGrps]);
      }
    }
  }, [group, jobfamily, setDisabled]);

  useEffect(() => {
    const values = getValues();
    const groupVal = values.records[index].group;
    if (activityGroupOption && groupVal) {
      const i = activityGroupOption.find((item) => groupVal === item.value);
      if (!i) {
        setValue(`records[${index}].group`, "");
        setGroup("");
        trigger();
      }
    }
  }, [getValues(), activityGroupOption]);

  console.log("Valid", group, jobfamily, isDisabled);

  const disableProjectDetails = (jobFamily, jobFamilyOptions) => {
    const projInfoEntryType = getProjectInfoEntryType(
      jobFamily,
      jobFamilyOptions
    );
    let isProjectDetailsDisabled;

    if (projInfoEntryType === "id") {
      isProjectDetailsDisabled = false;
    } else {
      isProjectDetailsDisabled = true;
    }

    return isProjectDetailsDisabled;
  };
  return (
    <>
      <StyledTableRow className={classes.root}>
        <TableCell align="left">
          <Controller
            render={(props) => (
              <Autocomplete
                className={classes.formControl}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                fullWidth
                //disableClearable
                // defaultValue={{ label: props.value }}
                // changed to value from default value
                // as value is persisiting
                // if we clear value for ActGrp Restriction func
                value={{ label: props.value }}
                options={jobFamiliyOption}
                getOptionLabel={(option) => option.label}
                //disabled={
                // disabled || group.value === "Leave" ? true : false
                //}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    //{...props}
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: 14 },
                    }}
                    size="small"
                    variant="outlined"
                    placeholder={timesheetJobFamily}
                    error={getErrors(errors.records, index, "family")}
                  />
                )}
               onChange={(_, data) => {
                  
                  if (data && data.value) {
                     props.onChange(data.value);
                  }
                  if (data) {
                    console.log("data.name in jobfamily onchange", data);
                     setJobfamily(data.value);
                     setValue(`records[${index}].details`, "");
                     setProject("");
                    onUpdate(index, -1);
                  }
                }}
              />
            )}
            name={`records[${index}].family`}
            defaultValue={record.family}
            control={control}
          />
        </TableCell>
        <TableCell align="center">
          <Controller
            render={(props) => (
              <Autocomplete
                disabled={disabled}
                className={classes.formControl}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                fullWidth
                //disableClearable
                //  defaultValue={{ label: props.value }}
                value={{ label: props.value }}
                options={activityGroupOption}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField
                    {...params}
                   // {...props}
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: 14 },
                    }}
                    size="small"
                    variant="outlined"
                    error={getErrors(errors.records, index, "group")}
                    placeholder={timesheetActivtyGroup}
                  />
                )}
               
                onChange={(_, data) => {
                  if (data && data.value) {
                    props.onChange(data.value);
                  }
                  if (data) {
                    setValue(`records[${index}].details`, "");
                    setValue(`records[${index}].freeForm`, "");
                    setProject("");
                    setGroup(data);
                    if (data.value == "Leave") {
                      // setValue(`records[${index}].family`, "Leave");
                      setValue(
                        `records[${index}].family`,
                        user.jobRole ? user.jobRole : ""
                      );
                      setJobfamily(user.jobRole);
                    } else {
                      // setValue(`records[${index}].family`, "");
                    }
                    trigger();
                    onUpdate(index, -1);
                  }
                }}
              />
            )}
            name={`records[${index}].group`}
            defaultValue={record.group}
            control={control}
          />
        </TableCell>
        <TableCell align="left">
          <FormControl className={classes.formControl} fullWidth>
            <TextField
              disabled={
                disabled || disableProjectDetails(jobfamily, jobFamiliyOption)
              }
              placeholder={t("other.lblProjectDetails")}
              fullWidth
              defaultValue={record.projectDetails}
              inputProps={{ style: { fontSize: 14 } }}
              size="small"
              variant="outlined"
              inputRef={register()}
              name={`records[${index}].projectDetails`}
              error={getErrors(errors.records, index, "projectDetails")}
            />
          </FormControl>
        </TableCell>
        <TableCell align="center">
          {showFreeForm ? (
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                disabled={disabled}
                placeholder={t("other.timeSheetDetails")}
                fullWidth
                defaultValue={record.freeForm}
                inputProps={{ style: { fontSize: 14 } }}
                size="small"
                variant="outlined"
                inputRef={register()}
                onChange={(e) => {
                  trigger();
                }}
                name={`records[${index}].freeForm`}
                error={getErrors(errors.records, index, "freeForm")}
              />
            </FormControl>
          ) : (
            <Autocomplete
              disabled={disabled}
              defaultValue={record.details}
              className={classes.formControl}
              selectOnFocus
              value={project}
              clearOnBlur
              handleHomeEndKeys
              fullWidth
              //disableClearable
              //options={group.value === "Leave" ? leaveOptions : projectOption}
              options={projectOption}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    style: { fontSize: 14 },
                  }}
                  size="small"
                  variant="outlined"
                  placeholder={
                    group.value === "Leave"
                      ? t("other.timesheetLeaveType")
                      : group?.value === "Project"
                      ? t("other.timeSheetDetails") + "*"
                      : t("other.timeSheetDetails")
                  }
                  error={getErrors(errors.records, index, "details")}
                />
              )}
              onChange={(_, data) => {
                if (data && data.value) {
                  props.onChange(data.value);
                }
                if (data) {
                  setProject(data);
                  setValue(`records[${index}].details`, data.name);
                  trigger(`records[${index}].details`);
                  onUpdate(index, -1);
                }
              }}
            />
          )}
        </TableCell>
        {days.map((days, i) => (
          <TableCell key={i} align="center">
            <Controller
              name={`records[${index}].day${i + 1}`}
              defaultValue={record[`day${i + 1}`]}
              control={control}
              render={(props) => (
                <TextField
                  size="small"
                  variant="outlined"
                  className={classes.hrsField}
                  type="number"
                  onKeyDown={(evt) =>
                    ["e", "E", "+", "-"].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  fullWidth
                  props
                  inputProps={{
                    min: 0,
                    max: 24,
                    className: classes.number,
                    readOnly: isDisabled,
                  }}
                  error={getErrors(errors.records, index, `day${i + 1}`)}
                  // defaultValue={props.value}
                  placeholder={"0"}
                  onChange={(e) => {
                    let eventValue = e.target.value;
                    e.persist();
                    e.target.value = e.target.value
                      ? parseFloat(e.target.value)
                      : 0;
                    e.target.value =
                      eventValue.indexOf(".") >= 0
                        ? eventValue.substr(0, eventValue.indexOf(".")) +
                          eventValue.substr(eventValue.indexOf("."), 3)
                        : eventValue;
                    props.onChange(e.target.value);
                    onUpdate(index, i + 1);
                  }}
                />
              )}
            />
          </TableCell>
        ))}
      </StyledTableRow>
    </>
  );
};

PunchRow.propTypes = {
  record: PropTypes.any,
  control: PropTypes.any,
  index: PropTypes.any,
  register: PropTypes.any,
  onDelete: PropTypes.any,
  onUpdate: PropTypes.func,
  setValue: PropTypes.any,
  trigger: PropTypes.any,
  setError: PropTypes.any,
  getValues: PropTypes.any,
  clearErrors: PropTypes.any,
  watch: PropTypes.any,
};

export default PunchRow;
